<template>
  <div class="page">
    <div class="rzrow">
      <div class="rzcon">
        <img src="../../assets/images/docrz.png" class="rzimg" alt="">
      </div>
      <div class="rztext">医生认证</div>
      <div class="sqin" v-if="!issq" @click="nopage()">去申请</div>
    </div>
    <div class="rzrow">
      <div class="rzcon">
        <img src="../../assets/images/hsrx.png" class="rzimg" alt="">
      </div>
      <div class="rztext">护士认证</div>
      <div class="sqin" v-if="!issq" @click="nopage()">去申请</div>
    </div>
    <div class="rzrow">
      <div class="rzcon">
        <img src="../../assets/images/otherrz.png" class="rzimg" alt="">
      </div>
      <div class="rztext">
        <div>其他认证</div>
        <div class="minitext" v-if="issq">获得日期：2023年03月09日 15：20</div>
      </div>
      <div class="sqin" v-if="!issq" @click="nopage()">去申请</div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  name: 'myidentity',
  data() {
    return {
      issq: false,
    }
  },
  created() {
    document.title = "华肤荟";
  },
  methods: {
    getident() {
      this.$router.push({ name: 'getidentity' })
    },
    nopage() {
      Dialog.alert({
        message: '暂未上线',
      }).then(() => {
        // on close
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  background: rgb(247, 248, 252);
  width: 100%;
  height: 100%;
  padding: .5rem 5%;
  box-sizing: border-box;
}

.rzrow {
  display: flex;
  flex-direction: row;
  margin-bottom: 0.5rem;
  background: #fff;
  border-radius: 0.106667rem;
  padding: 0.6rem 4%;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.044);
}

.rzimg {
  display: block;
  width: 100%;
}

.rzcon {
  width: 20%;
}

.rztext {
  display: block;
  align-self: center;
  box-sizing: border-box;
  padding-left: 5%;
  color: #0C2941;
  font-weight: bold;
  font-size: 19px;
}

.minitext {
  color: #697386;
  font-size: 10px;
  margin-top: .2rem;
}

.sqin {
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
  background: #1D2A5A;
  color: #fff;
  font-size: 13px;
  padding: 0.15rem 0.35rem;
  border-radius: 50rem;
}
</style>